export const getCurrentTarget = (state) => state.currentTarget || {}